import * as HoverCardPrimitive from "@radix-ui/react-hover-card";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import type { ComponentProps } from "react";
import { cn } from "../lib/cn";

const PANEL_CLASS =
  "z-50 rounded-lg border border-line bg-surface p-3 text-sm text-fg shadow-pop outline-none animate-fade-in motion-reduce:animate-none";

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverClose = PopoverPrimitive.Close;
export const PopoverAnchor = PopoverPrimitive.Anchor;

/** Focus moves into the panel; Esc / outside click close and return focus to the trigger. */
export function PopoverContent({ className, sideOffset = 6, align = "start", ...rest }: ComponentProps<typeof PopoverPrimitive.Content>) {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content sideOffset={sideOffset} align={align} className={cn(PANEL_CLASS, "w-72", className)} {...rest} />
    </PopoverPrimitive.Portal>
  );
}

export const HoverCard = HoverCardPrimitive.Root;
export const HoverCardTrigger = HoverCardPrimitive.Trigger;

/** Supplementary preview only — never put the sole copy of essential info or actions in a hover card. */
export function HoverCardContent({ className, sideOffset = 6, ...rest }: ComponentProps<typeof HoverCardPrimitive.Content>) {
  return (
    <HoverCardPrimitive.Portal>
      <HoverCardPrimitive.Content sideOffset={sideOffset} className={cn(PANEL_CLASS, "w-64", className)} {...rest} />
    </HoverCardPrimitive.Portal>
  );
}
